let REQUEST_URL = "https://gateway.alphaeditora.com.br/api/dashboard/";

if (process.env.NODE_ENV === "development") {
  REQUEST_URL = "http://localhost:6002/api/dashboard/";
}

export {REQUEST_URL};
